/** Linha curta de contexto por categoria do blog (texto fixo, escrito pela equipe). */
const DESCRICOES: Record<string, string> = {
  mmii:
    "Quadril, joelho, tornozelo e pé: avaliação, raciocínio clínico e reabilitação dos membros inferiores.",
  mmss:
    "Ombro, cotovelo, punho e mão: diagnóstico funcional e progressão de carga nos membros superiores.",
  "coluna-vertebral":
    "Cervical, torácica e lombar: dor, exame clínico e exercício terapêutico para a coluna.",
  dor: "Mecanismos da dor, dor persistente e manejo clínico centrado na pessoa.",
  "dor-orofacial":
    "ATM, disfunções temporomandibulares e dor de cabeça na prática do fisioterapeuta.",
  esporte:
    "Performance, prevenção de lesões e retorno ao esporte com critérios objetivos.",
  traumatologia:
    "Fraturas, pós-operatório e reabilitação do trauma musculoesquelético.",
  avaliacao:
    "Testes, medidas e roteiros de avaliação para decisões clínicas mais seguras.",
  "populacoes-especiais":
    "Envelhecimento, comorbidades e populações que exigem adaptações na reabilitação.",
};

export function descricaoCategoria(slug: string, nome: string): string {
  return (
    DESCRICOES[slug] ??
    `Artigos de fisioterapia musculoesquelética sobre ${nome.toLowerCase()}, com base em evidência.`
  );
}
